export default "__VITE_ASSET__DZ5M15Sl__"